<template>
  <ul class="text-[0.9em]" :class="stack ? 'space-y-0.5' : 'flex flex-wrap gap-x-3 gap-y-0.5'" :style="center ? { justifyContent: 'center' } : null">
    <li v-for="(contact, index) in contacts" :key="index" class="min-w-0 break-words">
      <a v-if="contact.href" :href="contact.href" target="_blank" rel="noopener noreferrer">{{ contact.text }}</a>
      <span v-else>{{ contact.text }}</span>
    </li>
  </ul>
</template>

<script setup>
// The contact details: in a row (wrapping), or one under another in a narrow column.
defineProps({
  contacts: { type: Array, required: true }, // [{ text, href? }]
  stack: { type: Boolean, default: false },
  center: { type: Boolean, default: false },
})
</script>
